import { faPhone } from '@fortawesome/free-solid-svg-icons';

export default {
  data() {
    return {
      icon: faPhone,
    };
  },
};
